import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { ImageService } from '../../services/image/image.service';
import { BrandSwitchTransitionService } from './brand-switch-transition.service';

@Component({
  selector: 'atom-brand-switch-transition',
  templateUrl: './brand-switch-transition.html',
  styleUrl: './brand-switch-transition.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BrandSwitchTransition {
  readonly transition = inject(BrandSwitchTransitionService);
  private readonly imageService = inject(ImageService);

  readonly logoSrc = computed(() => {
    const key = this.transition.logoKey();
    if (!key) {
      return '';
    }
    return this.imageService.getImageSource(key, 'gallery_lg');
  });
}
